export default __webpack_public_path__ + "static/media/check.0c5d944e.png";